import vClipboard from "./clipboard.js"

export default function setupDirective (Vue) {
  Vue.directive(vClipboard.name, vClipboard)
}